export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2740_19264)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3.875C20.7959 3.875 23.3272 5.00828 25.1595 6.84054C26.9917 8.67281 28.125 11.2041 28.125 14C28.125 16.7959 26.9917 19.3272 25.1595 21.1595C23.3272 22.9917 20.7959 24.125 18 24.125C15.2041 24.125 12.6728 22.9917 10.8405 21.1595C9.00828 19.3272 7.875 16.7959 7.875 14C7.875 11.2041 9.00828 8.67281 10.8405 6.84054C12.6728 5.00828 15.2041 3.875 18 3.875Z"
                    stroke="black"
                    strokeWidth="1.6875"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6466 11.6084C18.3067 11.6084 18.9044 11.876 19.337 12.3086C19.7697 12.7412 20.0372 13.3389 20.0372 13.9991C20.0372 14.6593 19.7697 15.2569 19.337 15.6896C18.9044 16.1222 18.3067 16.3898 17.6466 16.3898C16.9864 16.3898 16.3887 16.1222 15.9561 15.6896C15.5234 15.2569 15.2559 14.6593 15.2559 13.9991C15.2559 13.3389 15.5234 12.7412 15.9561 12.3086C16.3887 11.876 16.9864 11.6084 17.6466 11.6084Z"
                    stroke="black"
                    strokeWidth="1.6875"
                />
                <path
                    d="M18.4766 11.2556C19.1794 8.5527 19.9222 7.02442 20.5912 7.21287C21.5947 7.49554 23.1096 8.45944 22.9489 9.7159C22.8129 10.7794 21.5502 12.2904 20.0116 13.5716"
                    stroke="black"
                    strokeWidth="1.6875"
                />
                <path
                    d="M19.7653 15.4456C22.1187 16.9493 23.3427 18.128 22.9567 18.706C22.3778 19.5731 20.9929 20.716 19.8476 20.1749C18.8782 19.7169 17.8313 18.049 17.0883 16.1899"
                    stroke="black"
                    strokeWidth="1.6875"
                />
                <path
                    d="M14.9775 14.9097C12.3958 15.975 10.7283 16.3016 10.4762 15.6539C10.098 14.6823 9.95611 12.8923 11.0563 12.2645C11.9875 11.7331 13.9542 11.8322 15.9032 12.2899"
                    stroke="black"
                    strokeWidth="1.6875"
                />
                <path d="M16.3124 23.5625L15.2402 29.3399" stroke="black" strokeWidth="1.6875" />
                <path d="M19.6875 23.5625L20.7902 29.2837" stroke="black" strokeWidth="1.6875" />
                <path d="M24.75 26.375V28.5139" stroke="black" strokeWidth="1.6875" strokeLinecap="round" />
                <rect x="7.59375" y="29.4688" width="20.8125" height="2.8125" rx="1.40625" stroke="black" strokeWidth="1.6875" />
            </g>
            <defs>
                <clipPath id="clip0_2740_19264">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
